import { PublicKey } from '@velocity-exchange/sdk';
import { useCallback } from 'react';
import useVelocityClient from 'src/hooks/useVelocityClient';
import { fetchCurrentSubaccounts } from '@velocity-exchange/common';
import Env from 'src/environmentVariables/EnvironmentVariables';
import useVelocityAccountsStore from 'src/stores/useVelocityAccountsStore';
import { useSetupUserAccountStateAndListeners } from './useSetupUserAccountStateAndListeners';

export const useFetchAndSubscribeSubAccounts = () => {
	const velocityClient = useVelocityClient();
	const accountsSet = useVelocityAccountsStore((s) => s.set);

	const { setupUserAccountStateAndListeners } =
		useSetupUserAccountStateAndListeners();

	const fetchAndSubscribeSubAccounts = useCallback(
		(selectedSubAccountPubKey?: PublicKey, emulate?: boolean) => {
			if (velocityClient && velocityClient.wallet !== Env.defaultWallet) {
				const accounts = fetchCurrentSubaccounts(velocityClient);

				if (accounts.length === 0) {
					accountsSet((s) => {
						s.userAccountNotInitialized = true;
						s.hasLoadedAccounts = true;
					});
					return false;
				}

				setupUserAccountStateAndListeners(
					selectedSubAccountPubKey,
					undefined,
					emulate
				);

				accountsSet((s) => {
					s.userAccountNotInitialized = false;
					s.hasLoadedAccounts = true;
				});

				return true;
			} else {
				return false;
			}
		},
		[velocityClient, accountsSet, setupUserAccountStateAndListeners]
	);

	return { fetchAndSubscribeSubAccounts };
};
